import { formatMoney } from './utils-format-money.js';

class ProductPrice extends HTMLElement {
  connectedCallback() {
    // Store original price for reverting when no tier applies
    const priceRegularElement = this.querySelector('.price__regular');
    if (priceRegularElement) {
      this.originalPrice = priceRegularElement.innerHTML;
    }

    this.unsubscribeVariantChange = subscribe(
      `variant:changed:${this.dataset.productId}`,
      ({ html }) => {
        this.handlePriceChange(html);
      }
    );

    this.unsubscribeTierPriceChange = subscribe(
      'tier:price:change',
      ({ productId, tierPrice, unitPrice }) => {
        if (productId === this.dataset.productId) {
          this.handleTierPriceChange(tierPrice, unitPrice);
        }
      }
    );
  }

  disconnectedCallback() {
    this.unsubscribeVariantChange();
    this.unsubscribeTierPriceChange();
  }

  /**
   * Handle price change.
   * @param {HTMLElement} html - The HTML to render.
   */
  handlePriceChange(html) {
    const productPrice = html.querySelector('product-price');
    this.innerHTML = productPrice.innerHTML;

    // Update stored original price when variant changes
    const priceRegularElement = this.querySelector('.price__regular');
    if (priceRegularElement) {
      this.originalPrice = priceRegularElement.innerHTML;
    }
  }

  /**
   * Handle tier price change.
   * @param {Object} tierPrice - The tier price object
   * @param {number} unitPrice - The unit price in cents
   */
  handleTierPriceChange(tierPrice, unitPrice) {
    const priceRegularElement = this.querySelector('.price__regular');
    if (!priceRegularElement) return;

    // Check if there's a VAT asterisk to preserve
    const vatStar = priceRegularElement.querySelector('sup');
    const hasVatStar = !!vatStar;

    if (unitPrice && tierPrice) {
      // Apply tier pricing while preserving asterisk
      const formattedPrice = formatMoney(unitPrice);
      if (hasVatStar) {
        priceRegularElement.innerHTML = `${formattedPrice}<sup class="text-primary-950">*</sup>`;
      } else {
        priceRegularElement.textContent = formattedPrice;
      }
    } else {
      // Revert to original price when no tier applies
      if (this.originalPrice) {
        priceRegularElement.innerHTML = this.originalPrice;
      }
    }
  }
}

customElements.define('product-price', ProductPrice);
